





































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import { Search, SortDirection } from '@/data/models/search.model';

@Component
export default class ContattoList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: () => [] }) selected!: Contatto[];
	
	@Inject('CrudService') crudService!: CrudService<Contatto>;

	rows: Contatto[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('contact');
	checkedRows: Contatto[] = [];
	ct!: number;

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadContatti() {

		const datareq = this.crudService.searchEntities(
			Contatto,
			'contact',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Contatto,
			'contact',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.ct = results[1].ct;
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editContatto(item: Contatto) {
		this.$emit('edit', item);
	}

	openContatto(item: Contatto) {
		this.$emit('open', item);
	}

	deleteContatto(item: Contatto) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadContatti();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadContatti();
	}

	onCheck(checked: Contatto[]) {
		this.$emit('update:selected', checked);
	}

}
